module.exports = __webpack_public_path__ + "static/media/RiskIt_Icon.6503c296.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ico/RiskIt_Icon.svg
// module id = 288
// module chunks = 0